import { DeviceType } from 'app/shared/model/enumerations/device-type.model';

export interface IDevice {
  id?: number;
  deviceType?: DeviceType | null;
  manufacturer?: string | null;
  model?: string | null;
  imageContentType?: string | null;
  image?: string | null;
  objectKey?: string | null;
  description?: string | null;
}

export const defaultValue: Readonly<IDevice> = {};
